// GraphQL mutations for authentication
import {
  USER_FRAGMENT,
  LOGIN_RESPONSE_FRAGMENT,
  REGISTRATION_RESPONSE_FRAGMENT,
  VERIFY_OTP_RESPONSE_FRAGMENT
} from '../fragments/auth';

// Login with email and password
// Note: This mutation uses variables for proper security
export const USER_LOGIN_LOCAL_MUTATION = `
  mutation userLoginLocal($emailOrPhone: String!, $password: String!) {
    userLoginLocal(data: {emailOrPhone: $emailOrPhone, password: $password}) {
      ${LOGIN_RESPONSE_FRAGMENT}
    }
  }
`;

// Register new user
export const REGISTER_MUTATION = `
  mutation register($input: SignUpInput!) {
    register(input: $input) {
      ${REGISTRATION_RESPONSE_FRAGMENT}
    }
  }
`;

// Verify registration with OTP
export const VERIFY_REGISTRATION_MUTATION = `
  mutation verifyRegistration($input: VerifyRegisterInput!) {
    verifyRegistration(input: $input) {
      ${VERIFY_OTP_RESPONSE_FRAGMENT}
    }
  }
`;

// Resend OTP
export const RESEND_OTP_MUTATION = `
  mutation resendOTP($input: ResendOTPInput!) {
    resendOTP(input: $input) {
      message
      otpExpiredAt
    }
  }
`;

// Forgot password
export const FORGOT_PASSWORD_MUTATION = `
  mutation forgotPassword($input: ForgotPasswordInput!) {
    forgotPassword(input: $input) {
      message
      email
      otpExpiredAt
    }
  }
`;

// Reset password
export const RESET_PASSWORD_MUTATION = `
  mutation resetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      message
    }
  }
`;

// Soft delete account
export const SOFT_DELETE_ACCOUNT_MUTATION = `
  mutation softDeleteAccount {
    softDeleteAccount {
      id
      email
      name
      phone
    }
  }
`;

// Refresh token
export const REFRESH_TOKEN_MUTATION = `
  mutation refreshTokenUser {
    refreshTokenUser {
      refreshedToken
    }
  }
`;

// Login with Google
export const USER_LOGIN_WITH_GOOGLE_MUTATION = `
  mutation userLoginWithGoogle($data: UserLoginGoogleInput) {
    userLoginWithGoogle(data: $data) {
      ${LOGIN_RESPONSE_FRAGMENT}
    }
  }
`;